export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"apple-mobile-web-app-title","content":"Go7Seas"},{"name":"description","content":"Bei go7seas-kreuzfahrten können Sie Seereisen online buchen und Informationen über Ihr Kreuzfahrtschiff finden. Kreuzfahrten, nach Ihrem Wunsch mit oder ohne Anreisepaket, von MSC, Costa, Cunard, AIDA, Royal Caribbean, Princess, Celebrity und anderen Reedereien."},{"name":"keywords","content":"Kreuzfahrt, Kreuzfahrten, Seereisen, Schiffsreise, Schiffsreisen, Flusskreuzfahrt, Flusskreuzfahrten, MSC Kreuzfahrten, Costa Kreuzfahrten, Kreuzfahrt Karibik, AIDA, Kreuzfahrt Mittelmeer, Royal Caribbean, Celebrity, Princess, Carnival, Cunard, TUI Cruises"}],"link":[{"rel":"preconnect","href":"//app.eu.usercentrics.eu"},{"rel":"preconnect","href":"//api.eu.usercentrics.eu"},{"rel":"preload","href":"//app.eu.usercentrics.eu/browser-ui/latest/loader.js","as":"script"},{"rel":"icon","type":"image/png","href":"/favicon/favicon-48x48.png","sizes":"48x48"},{"rel":"icon","type":"image/svg+xml","href":"/favicon/favicon.svg"},{"rel":"shortcut icon","href":"/favicon/favicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/favicon/apple-touch-icon.png"},{"rel":"manifest","href":"/favicon/site.webmanifest.json","crossorigin":"use-credentials"}],"style":[],"script":[{"type":"text/javascript","children":"\n            window.UC_UI_SUPPRESS_CMP_DISPLAY = localStorage.getItem('uc_user_interaction') === 'true';\n            function setSuppressCMPDisplay() {\n                window.UC_UI_SUPPRESS_CMP_DISPLAY = true\n            }\n            window.addEventListener('ucConsentUI', function() {\n                const usercentrics = window.UC_UI;\n                if (!window.UC_UI_SUPPRESS_CMP_DISPLAY) {\n                    usercentrics.addEventListener('consentUIReady', function() {\n                        setSuppressCMPDisplay();\n                    });\n                }\n            });\n          "},{"type":"text/javascript","children":"\n            window.dataLayer = window.dataLayer || [];\n            function gtag() {\n                dataLayer.push(arguments);\n            }\n            gtag(\"consent\", \"default\", {\n                ad_user_data: \"denied\",\n                ad_personalization: \"denied\",\n                ad_storage: \"denied\",\n                analytics_storage: \"denied\",\n                wait_for_update: 2000\n            });\n          "}],"noscript":[{"children":"<h1>Diese Seite benötigt Javascript</h1>"}],"htmlAttrs":{"lang":"de"},"title":"Kreuzfahrten, Flüge & Hotels buchen bei www.go7seas-kreuzfahrten.de"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true